import React from 'react';
import { compose, withPropsOnChange } from 'recompose';
import { connect } from 'react-redux';
import { connectRequest } from 'redux-query';
import { browserHistory } from 'react-router';
import Table from 'rc-table';
import { Checkbox, RaisedButton } from 'material-ui';
import _ from 'lodash';
import moment from 'moment';
import { getEntities } from 'dash-front/selectors';
import { fetchAccountConfig } from 'dash-front/admin/actions/accounts';

const COLUMNS = [
    {
        key: 'username',
        dataIndex: 'username',
        title: 'Username'
    },
    {
        key: 'createdAt',
        title: 'Created',
        render: ({ createdAt }) => <span>{moment(createdAt).format('DD MMM YYYY')}</span>
    },
    {
        key: 'permissions',
        title: 'Permissions',
        render: ({ permissions }) => (
            <div>
                <Checkbox disabled checked={permissions.htmlWidgets} label="HTML widgets" />
                <Checkbox disabled checked={permissions.smWidgets} label="Social media widgets" />
                <Checkbox disabled checked={permissions.campaigns} label="Campaigns/automations" />
                <Checkbox disabled checked={permissions.messageServices} label="Message services" />
                <Checkbox disabled checked={permissions.tvSchedule} label="TV Schedule API" />
                <Checkbox disabled checked={permissions.gridMakerTool} label="Grid Maker Tool" />
            </div>
        )
    }
];

const AccountsList = ({ items }) => {
    return (
        <div>
            <RaisedButton primary label="Add user" onTouchTap={() => browserHistory.push('/admin/accounts/create')} />
            <Table
                data={items}
                rowKey="_id"
                style={{ marginTop: 12 }}
                onRowClick={({ username }) => browserHistory.push(`/admin/accounts/edit/${username}`)}
                columns={COLUMNS}
            />
        </div>
    );
};

export default compose(
    connectRequest(fetchAccountConfig),
    connect(state => ({ accounts: getEntities(state).accounts })),
    withPropsOnChange(
        (cur, next) => {
            return cur.accounts !== next.accounts;
        },
        ({ accounts }) => {
            const items = _.isObject(accounts) ? accounts : {};
            return {
                items: Object.keys(items)
                    .map(name => items[name])
                    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
            };
        }
    )
)(AccountsList);



/** WEBPACK FOOTER **
 ** ../src/dash/front/admin/components/Account/AccountsList.js
 **/